import React from 'react';
import { SalesButton } from './SalesButton';
import { Check } from 'lucide-react';
export function PriceSection() {
  return <section id="oferta" className="py-20 bg-white px-4 sm:px-6 lg:px-8" data-id="element-118">
      <div className="max-w-4xl mx-auto" data-id="element-119">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-slate-100" data-id="element-120">
          <div className="bg-slate-900 p-8 text-center" data-id="element-121">
            <h2 className="text-3xl font-bold text-white mb-2" data-id="element-122">
              Oferta Especial de Lanzamiento
            </h2>
            <p className="text-rose-300 font-medium" data-id="element-123">
              Disponible por tiempo limitado
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-124">
            <div className="flex flex-col md:flex-row justify-between items-center mb-12" data-id="element-125">
              <div className="mb-8 md:mb-0 text-center md:text-left" data-id="element-126">
                <p className="text-slate-500 text-lg line-through mb-1" data-id="element-127">
                  Precio Regular: $37
                </p>
                <div className="flex items-baseline justify-center md:justify-start" data-id="element-128">
                  <span className="text-6xl font-extrabold text-slate-900" data-id="element-129">
                    $6.36
                  </span>
                  <span className="text-xl text-slate-600 ml-2" data-id="element-130">USD</span>
                </div>
                <p className="text-sm text-green-600 font-bold mt-2 bg-green-50 inline-block px-3 py-1 rounded-full" data-id="element-131">
                  Ahorras 83% HOY
                </p>
              </div>

              <div className="w-full md:w-auto" data-id="element-132">
                <SalesButton className="w-full md:w-auto text-lg px-10 py-4 shadow-xl shadow-rose-200" data-id="element-133">
                  OBTENER ACCESO INMEDIATO
                </SalesButton>
                <p className="text-xs text-center text-slate-400 mt-3" data-id="element-134">
                  Pago único y seguro. Garantía de 30 días.
                </p>
              </div>
            </div>

            <div className="border-t border-slate-100 pt-8" data-id="element-135">
              <h3 className="text-lg font-bold text-slate-900 mb-6" data-id="element-136">
                Todo lo que incluye:
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-137">
                {["El Manual Completo 'Disciplina Anti-Flojera'", 'Plan de Acción de 21 Días', "Guía de 'Rescate Mental' para días difíciles", 'Listado de "Comidas Pro-Energía"'].map((feature, i) => <div key={i} className="flex items-start" data-id="element-138">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-139">
                      <Check className="h-4 w-4 text-green-600" data-id="element-140" />
                    </div>
                    <span className="ml-3 text-slate-600" data-id="element-141">{feature}</span>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="bg-rose-50 p-6 text-center text-sm text-rose-800 font-medium" data-id="element-142">
            Menos de lo que cuesta una cena fuera. Una inversión en ti misma que
            dura para siempre.
          </div>
        </div>
      </div>
    </section>;
}